"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const URITemplate = require("uri-templates");
const namespaces_1 = require("../namespaces");
const CollectionsCollection_1 = require("./Collections/CollectionsCollection");
const LinksCollection_1 = require("./Collections/LinksCollection");
const OperationsCollection_1 = require("./Collections/OperationsCollection");
const TypesCollection_1 = require("./Collections/TypesCollection");
const MappingsBuilder_1 = require("./MappingsBuilder");
/**
 * Provides a base functionality for resources that has expandable template.
 * @class
 */
class TemplatedResource {
    /**
     * Initializes a new instance of the {@link TemplatedOperation} class.
     * @param {IPointingResource} resource Original resource to create templated one from.
     * @param {IIriTemplate} template IRI template to take template from.
     * @param {Iterable<string>} type Types of the resource.
     */
    constructor(resource, template, type) {
        this.baseUrl = resource.baseUrl;
        this.iri = resource.iri;
        this.links = LinksCollection_1.default.empty;
        this.collections = new CollectionsCollection_1.default();
        this.type = new TypesCollection_1.default(type);
        this.target = null;
        this.template = template.template;
        this.mappings = template.mappings;
        this.operations = OperationsCollection_1.default.empty;
    }
    /** @inheritDoc */
    expandTarget(mappedVariables) {
        if (mappedVariables instanceof Function) {
            const builder = new MappingsBuilder_1.default(this.mappings);
            mappedVariables(builder);
            return this.expandTarget(builder.complete());
        }
        const templateVariables = mappedVariables;
        const targetUri = URITemplate(this.template)
            .fillFromObject(templateVariables)
            .toString();
        const target = targetUri.match(/^[a-zA-Z][a-zA-Z0-9_]*:/) ? targetUri : new URL(targetUri, this.baseUrl).toString();
        return this.createInstance({
            baseUrl: this.baseUrl,
            collections: this.collections,
            iri: this.getNextIri(),
            links: this.links,
            operations: this.operations,
            target: { iri: target, type: TypesCollection_1.default.empty },
            type: new TypesCollection_1.default(this.type.except(namespaces_1.hydra.IriTemplate).toArray())
        });
    }
}
exports.default = TemplatedResource;
//# sourceMappingURL=TemplatedResource.js.map